import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'

import { useOpenEditMaskModal } from '../../../utils/routes/modals/modalsActions'
import { prop } from 'ramda'
import { useRemoveMasks } from './_requests/removeMasks'

const useSingleActions = (item, opts) => {
  const hide = opts.hide || []

  const canEdit = useSessionPermission('editMasks')
  const canDelete = useSessionPermission('deleteMasks')
  const { t } = useTranslation('common')

  const openEditModal = useOpenEditMaskModal()

  const [deleteItems, { loading }] = useRemoveMasks()

  return [
    ...appendIf(canEdit, {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: () => openEditModal(item.id)
    }),

    ...appendIf(canDelete, {
      value: t('remove'),
      color: COLORS.red,
      icon: 'BsTrash',
      onClick: () => deleteItems([item.id])
    })
  ]
}

const useMultiActions = (ids, opts) => {
  const [deleteItems, { loading }] = useRemoveMasks()
  const canDelete = useSessionPermission('deleteMasks')
  const { t } = useTranslation('common')

  return [
    ...appendIf(canDelete, {
      value: t('remove'),
      color: COLORS.red,
      icon: 'BsTrash',
      onClick: () => deleteItems(ids)
    })
  ]
}

export const useMaskActionsList = (item, ids, opts = {}) => {
  const singleOptions = useSingleActions(item, opts)
  const multiOptions = useMultiActions(ids, opts)

  if (!!ids && ids.length > 1) return multiOptions
  if (!!item) return singleOptions

  return multiOptions
}
